<template>
  <div>
    <highcharts :id="id" class="hc" :options="chartOptions" ref="chart"></highcharts>

  
  </div>
</template>

<script>
import highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(highcharts)

var idx = 0

export default {
  props: {
    QuestM: {
      type: Object,
      default: () => {},
    },
    QuestD: {
      type: Array,
      default: () => {},
    },
  },
  created() {
    this.init()
    // this.saveCharts()
  },
  data() {
    idx++
    return {
      id: 'ChartPie' + String(idx),
      chartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
        },
        title: {
          text: this.QuestM.cnName,
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            },
          },
        },
        series: [
          {
            name: '百分比',
            colorByPoint: true,
            data: [],
          },
        ],

        //
      },
    }
  },
  mounted() {

    /**
     * Create a obj array.
     */

    var obj = {
      'id': this.id,
      'option': this.chartOptions
    }

    this.$store.state.charts.push(obj);
    /**
     * 
     */
  
    // var chart = Highcharts.chart( this.id, this.chartOptions )
    // window.console.log(chart)
    // this.$store.state.charts.push(chart);


    
  },
  methods: {
    init() {
      var AllSelectNum = 0

      var cnNameArray = this.QuestM.item.split('$')
      for (let i = 0; i < this.QuestD.length; i++) {
        if (this.QuestD[i].enName == this.QuestM.enName) {
          AllSelectNum += this.QuestD[i].sum
        }
      }
      for (let i = 0; i < this.QuestD.length; i++) {
        if (this.QuestD[i].enName == this.QuestM.enName) {
          this.chartOptions.series[0].data.push({
            name: cnNameArray[this.QuestD[i].options],
            y: this.QuestD[i].sum / AllSelectNum,
          })
        }
      }

      // window.console.log(this.id)
      // let chart = Highcharts.chart(this.id,this.chartOptions);
      // window.console.log('chart');
      // window.console.log(chart);
      // this.$store.state.charts.push(chart);

      // window.console.log('charts');
      // window.console.log(this.$store.state.charts);
    },
    //     saveCharts(){
    // window.console.log(this.id )
    //       let chart = Highcharts.chart(this.id,this.chartOptions);
    //       window.console.log('chart');
    //       window.console.log(chart);
    //       this.$store.state.charts.push(chart);

    //       window.console.log('charts');
    //       window.console.log(this.$store.state.charts);
    //     }
  },
}
</script>
